<template>
  <hl-group align="items-middle" class="list-total" :class="cls">
    <hl-icon size="xs" class="m-r-xs">
      <svg viewBox="0 0 16 16" version="1.1">
        <g stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
          <path v-if="checked" d="M13.6042969,0.533576817 L13.6039805,10.4732904 C13.6016137,11.571218 13.5756715,11.9976489 13.4670821,12.4320064 C13.1222747,13.811236 12.0205792,14.9129315 10.5724932,15.3265953 L10.3848437,15.3682458 C10.0344432,15.4359598 9.48802787,15.4578615 8.69782901,15.4626044 L7.52718642,15.4634938 C6.42925875,15.4611269 5.76850445,15.4351847 5.33414696,15.3265953 C3.95491738,14.9817879 2.85322188,13.8800924 2.43955807,12.4320064 C2.34648147,12.0597 2.31412522,11.6932172 2.30528941,10.9045261 L2.30265932,10.473015 L2.30234327,0.533576817 L13.6042969,0.533576817 Z M12.0103356,2.12624349 L3.8946766,2.12624349 L3.89640829,10.6234012 C3.89941141,11.3690094 3.91678164,11.6798536 3.98418345,11.9162068 L4.02612424,12.0399047 C4.20905335,12.8935739 4.87744549,13.5448278 5.79720622,13.8076916 L5.88459097,13.8261272 C6.01033628,13.847997 6.18213956,13.859419 6.50954571,13.8651455 L7.56684713,13.8703682 L8.81547999,13.8684046 C9.56203454,13.8615113 9.94201049,13.8336443 10.1803915,13.7400291 C11.0340607,13.5571 11.6853145,12.8887079 11.9481784,11.9689471 L11.9713789,11.8563876 C11.9999583,11.6786626 12.0082477,11.4035708 12.0103356,10.6181765 L12.0103356,2.12624349 Z M8.79666667,4.40497253 L8.79666667,7.99830585 L7.20333333,7.99830585 L7.20333333,4.40497253 L8.79666667,4.40497253 Z" fill-rule="nonzero" />
          <path v-else d="M7.22131097,1.02302406 C10.8188214,1.02302406 13.735239,3.93945118 13.735239,7.53698247 C13.735239,8.73345423 13.4119411,9.8820658 12.8110967,10.8833651 L12.6977811,11.0629204 L15.317794,13.6834353 C15.5686156,13.934044 15.6142196,14.3123975 15.4546218,14.6094429 L15.3938225,14.7051599 L15.3178232,14.7931334 C15.1686702,14.9422864 14.9696377,15.0230241 14.7629735,15.0230241 C14.5976551,15.0230241 14.4372114,14.9713523 14.3032601,14.8743056 L14.2081017,14.7931113 L11.689463,12.2734855 L11.5432093,12.4107512 C10.5101724,13.3278538 9.21415349,13.8957738 7.82290275,14.0234241 L7.52338109,14.0440057 L7.22131097,14.0509105 C3.62377968,14.0509105 0.707352557,11.1344929 0.707352557,7.53698247 C0.707352557,3.93944641 3.62377491,1.02302406 7.22131097,1.02302406 Z M7.22131097,2.59250469 C4.49498666,2.59250469 2.27683319,4.81066278 2.27683319,7.53698247 C2.27683319,10.263284 4.49499887,12.4814451 7.22131097,12.4814451 C9.9476049,12.4814451 12.1657736,10.2632718 12.1657736,7.53698247 C12.1657736,4.81067566 9.94760259,2.59250469 7.22131097,2.59250469 Z" fill-rule="nonzero" />
        </g>
      </svg>
    </hl-icon>
    {{ text.tip }}<span class="text-link">{{ text.info }}</span><span v-show="text.info">条数据</span>
  </hl-group>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { HlGroup, HlIcon } from 'hongluan-ui'

export default defineComponent({
  components: { HlGroup, HlIcon },
  props: {
    total: {
      type: Number,
      default: 0,
    },
    search: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const cls = computed(() => {
      if (props.checked && props.total > 0) return 'is-checked'
      if (props.search) return 'is-search'
      return 'default'
    })
    const text = computed(() => {
      if (props.checked && props.total > 0) {
        return {
          tip: '已选',
          info: `${props.total}`,
        }
      }
      if (props.search) {
        if (props.total > 0) {
          return {
            tip: '查询结果',
            info: `${props.total}`,
          }
        }
        return {
          tip: '暂无查询结果',
          info: ``,
        }
      }
      if (props.total > 0) {
        return {
          tip: '共计',
          info: `${props.total}`,
        }
      } else {
        return {
          tip: '暂无数据',
          info: ``,
        }
      }
    })

    return {
      cls,
      text,
    }
  },
})
</script>
